import { render } from "./collection-filters.vue?vue&type=template&id=267d3f76"
import script from "./collection-filters.vue?vue&type=script&lang=js"
export * from "./collection-filters.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__